import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { SearchProvider } from './context/SearchContext';
import { UserProvider } from './context/UserContext';

import { ThemeProvider } from '@mui/material/styles';
import theme from './themes/globalTheme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <UserProvider>
        <SearchProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
        </SearchProvider>
      </UserProvider>
      
    </ThemeProvider>
  </React.StrictMode>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
